// @flow

import _ from 'lodash';

import ApiObject from './ApiObject';
import Timelapse from './Timelapse';
import Payin from './Payin';

export default class PaymentStatistics extends ApiObject {

  paymentsNumber: number = 0;
  checksNumber: number = 0;

  timelapse: Timelapse = new Timelapse();
  // fromTime: number = 0;
  // toTime: number = 0;

  payins: Array<Payin> = []; // Array of Payin
  tips: Array = [];

  /**
   * Include tips
   */
  totalAmountPaid: number = 0;

  totalTipsPaid: number = 0;

  postJsonAssignation(data: Object) {
    super.postJsonAssignation(data);

    // -- deserialize timelapse
    this.timelapse = new Timelapse();
    this.timelapse.setFromTime(data.fromTime / 1000);
    this.timelapse.setToTime(data.toTime / 1000);

    // -- deserialize payins
    this.payins = [];
    const _this = this;

    _.each(data.payins, (payinData: Object) => {
      const payin:Payin = new Payin();
      payin.fromJson(payinData);
      _this.payins.push(payin);
    });
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/PaymentStatistics.js